import React, { useEffect, useState } from 'react';
import emailjs from 'emailjs-com';
import '../css/confirmacao.css';
import '../css/components.css';
import logo from '../images/logo.png';
import Modal from '../components/ModalConfirmação';

const ConfirmacaoPresenca = () => {
  const [showScroll, setShowScroll] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const [modalMessage, setModalMessage] = useState('');

  const handleScroll = () => {
    setShowScroll(window.scrollY > 300);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const [nome, setNome] = useState('');
  const [levaAcompanhante, setLevaAcompanhante] = useState(false);
  const [nomeAcompanhante, setNomeAcompanhante] = useState('');
  const [temFilhos, setTemFilhos] = useState(false);
  const [nomeFilho1, setNomeFilho1] = useState('');
  const [nomeFilho2, setNomeFilho2] = useState('');

  const openModal = (title, message) => {
    setModalTitle(title);
    setModalMessage(message);
    setShowModal(true);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const currentDate = new Date();
    const deadline = new Date('2026-08-16T23:59:59');

    if (currentDate > deadline) {
      openModal('Prazo Expirado', 'Desculpe, o prazo de confirmação expirou.');
      return;
    }

    if (!nome) {
      openModal('Campo Obrigatório', 'Por favor, insira seu nome.');
      return;
    }

    const templateParams = {
      nome,
      levaAcompanhante: levaAcompanhante ? 'Sim' : 'Não',
      nomeAcompanhante: levaAcompanhante ? nomeAcompanhante : 'Nenhum acompanhante',
      temFilhos: temFilhos ? 'Sim' : 'Não',
      nomeFilho1: temFilhos ? nomeFilho1 || 'Não foi informado' : 'Nenhum filho',
      nomeFilho2: temFilhos ? nomeFilho2 || 'Não foi informado' : 'Nenhum filho',
      to_email: 'diegof657@gmail.com',
    };

    emailjs
      .send('service_42bjl8s', 'template_sypv5sn', templateParams, 'GRZvHGzmU-6EZ85z4')
      .then(
        () => {
          openModal('Confirmação Enviada', 'Sua confirmação foi enviada com sucesso!');
        },
        () => {
          openModal('Erro', 'Ocorreu um erro ao enviar sua confirmação.');
        }
      );
  };

  return (
    <div className="wedding-page">
      <Modal
        show={showModal}
        onClose={() => setShowModal(false)}
        title={modalTitle}
      >
        <p>{modalMessage}</p>
      </Modal>

      <section className="rsvp-section">
        <h2 className="rsvp-title">Dress Code</h2>
        <p className="text-description">
          Para mantermos a harmonia do evento, pedimos atenção às seguintes orientações:
        </p>
        <br />

        <h3 className="titleDressCode">👗 Mulheres:</h3>
        <br />
        <p className="text-description">
          Vestido longo preferencialmente.<br />
          <strong>Evitar</strong> a cor rosé (rosa claro, branco ou tons envelhecido). <br />
          Utilizar saltos confortáveis, para aproveitar bem a festa.
        </p>
        <br />

        <h3 className="titleDressCode">🤵 Homens:</h3>
        <br />
        <p className="text-description">
          O uso de terno e traje social é obrigatório. <br />
          <strong>Evitar</strong> ternos em tons de cinza claro e azul marinho. <br />
          O uso de gravata é opcional.
        </p>
        <br />
        <p className="text-description">
          Estamos ansiosos para celebrar esse dia especial com vocês e agradecemos a atenção e o carinho.
        </p>
        <p className="text-description">Com amor, Os Noivos</p>
      </section>

      <div className="banner-container">
        <div className="banner"></div>
        <div className="logo-container">
          <img src={logo} alt="Logo" className="logo" />
        </div>
        <div className="banner"></div>
      </div>

      <section className="rsvp-section">
        <h2 className="rsvp-title">Confirmação de Presença</h2>
        <p className="text-description">
          Por favor, confirme a sua presença para nossa cerimônia <br />
          Lembrando que convidados não convidam
        </p>
        <br />

        <form onSubmit={handleSubmit} className="rsvp-form">
          <div className="form-field">
            <label htmlFor="nome" className="form-label">Seu Nome:</label>
            <input
              type="text"
              id="nome"
              className="form-input"
              value={nome}
              onChange={(e) => setNome(e.target.value)}
              required
            />
          </div>

          <div className="form-field">
            <label htmlFor="levaAcompanhante" className="form-label">Possui cônjuge?</label>
            <input
              type="checkbox"
              id="levaAcompanhante"
              className="form-checkbox"
              checked={levaAcompanhante}
              onChange={(e) => setLevaAcompanhante(e.target.checked)}
            />
          </div>

          {levaAcompanhante && (
            <div className="form-field">
              <label htmlFor="nomeAcompanhante" className="form-label">Nome do Acompanhante:</label>
              <input
                type="text"
                id="nomeAcompanhante"
                className="form-input"
                value={nomeAcompanhante}
                onChange={(e) => setNomeAcompanhante(e.target.value)}
                required
              />
            </div>
          )}

          <div className="form-field">
            <label htmlFor="temFilhos" className="form-label">Possui filhos?</label>
            <input
              type="checkbox"
              id="temFilhos"
              className="form-checkbox"
              checked={temFilhos}
              onChange={(e) => setTemFilhos(e.target.checked)}
            />
          </div>

          {temFilhos && (
            <>
              <div className="form-field">
                <label htmlFor="nomeFilho1" className="form-label">Nome do Filho 1:</label>
                <input
                  type="text"
                  id="nomeFilho1"
                  className="form-input"
                  value={nomeFilho1}
                  onChange={(e) => setNomeFilho1(e.target.value)}
                  required
                />
              </div>

              <div className="form-field">
                <label htmlFor="nomeFilho2" className="form-label">Nome do Filho 2:</label>
                <input
                  type="text"
                  id="nomeFilho2"
                  className="form-input"
                  value={nomeFilho2}
                  onChange={(e) => setNomeFilho2(e.target.value)}
                  required
                />
              </div>
            </>
          )}

          <button type="submit" className="submit-button">Enviar Confirmação</button>
        </form>
      </section>

      <div className="banner-container">
        <div className="banner"></div>
        <div className="wedding-page">
          {showScroll && (
            <button className="scroll-to-top" onClick={scrollToTop}>
              ↑ <br />
            </button>
          )}
        </div>
        <div className="banner"></div>
      </div>
    </div>
  );
};

export default ConfirmacaoPresenca;